module.exports = __webpack_public_path__ + "img/timeline_miscevent-7.7b80ca0b.jpg";